import { Box, Typography, TextField, Button } from '@mui/material';
import {
  BUTTON_CONTINUE,
  EMAIL_LABEL,
  EMAIL_PROMPT_DESCRIPTION,
  EMAIL_PROMPT_TITLE,
} from '../../../constants';
import { IEnterEmailFormProps } from '../../../constants/types';
import LoginRegistrationHeader from '../../../components/layout/LoginRegistrationHeader';
import AnnotationIcon from '/images/annotationHeart.svg';
import { useAppSelector } from '../../../redux/hooks';

const EnterEmailForm: React.FC<IEnterEmailFormProps> = ({
  disableSubmit,
  isPending,
  formik,
}) => {
  const { mobile_number = '', country_code = '' } =
    useAppSelector((state) => state.auth?.constants) || {};
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
    isValid,
  } = formik;

  return (
    <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
      <LoginRegistrationHeader />
      <Box pt={5} mb={12.25}>
        <Typography variant="h4" color="primary" mb={1.5}>
          {EMAIL_PROMPT_TITLE}
        </Typography>
        <Typography variant="body1">{EMAIL_PROMPT_DESCRIPTION}</Typography>
      </Box>
      <TextField
        name="email"
        label={EMAIL_LABEL}
        fullWidth
        type="email"
        required
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.email && Boolean(errors.email)}
        helperText={touched.email && errors.email}
      />
      <Box
        sx={{ pt: 7.5, mt: 'auto', mb: 4.5, gap: 2 }}
        className="d-flex flex-column"
      >
        <Box
          sx={{
            bgcolor: '#fff',
            gap: 1.5,
            p: 2.5,
          }}
          className="d-flex align-items-start rounded-50"
        >
          <Box
            sx={{
              bgcolor: '#D9DAFF',
              color: 'common.white',
              p: 1,
              borderRadius: 2,
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <img src={AnnotationIcon} />
          </Box>
          <Box className="flex-1">
            <Typography variant="body2" sx={{ mb: 1.25 }}>
              If you're having trouble, check the email used to book your
              appointment at Stoneygate or{' '}
              <Typography
                component="a"
                fontWeight="bold"
                href={`tel:${country_code}${mobile_number}`}
              >
                Contact us
              </Typography>
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          disabled={!isValid || disableSubmit || isPending}
        >
          {BUTTON_CONTINUE}
        </Button>
      </Box>
    </form>
  );
};

export default EnterEmailForm;
